import type { UserPublicID } from "@atoms/atom-types";

export const ImportServiceUserID = "import-service" as UserPublicID;
